import React from "react";
import { TableRow as MuiTableRow, TableCell as MuiTableCell } from "@mui/material";
import { sanitize } from "../../utils/sanitize";

import makeStyles from "@mui/styles/makeStyles";

const useCellStyles = makeStyles(theme => ({
  root: {
    fontSize: "inherit!important",
    paddingTop: "12px !important",
    paddingRight: "0px !important",
    paddingBottom: "12px !important",
    paddingLeft: "16px !important",
    verticalAlign: "middle!important",
  },
  sizeSmall: {
    paddingTop: "0px !important",
    paddingBottom: "0px !important",
    paddingRight: "2px !important",
  },
  total: {
    backgroundColor: "#FFFBE6",
    '& .MuiTableCell-root': {
      fontWeight: 'bold !important',
    }
  }

}));

type TableCellType = string | React.JSX.Element;

export interface TableRowProps {
  row: TableCellType[];
  rowData?: any;
  onRowClick?: (isTotal: boolean, rowData: any) => void;
}

const TableRow: React.FC<TableRowProps> = ({ row, rowData, onRowClick }) => {
  const cellStyles = useCellStyles();
  const isTotal = row.some(cell => {
    if (typeof cell === 'string') {
      return cell.toLowerCase().includes('total');
    }
    if (React.isValidElement(cell)) {
      const element = cell as React.ReactElement<{ children?: React.ReactNode }>;
      const children = element.props.children;
      if (typeof children === 'string') {
        return children.toLowerCase().includes('total');
      }
    }
    return false;
  });

  return (
    <MuiTableRow 
      hover={!isTotal}
      tabIndex={-1} 
      classes={isTotal ? { root: cellStyles.total } : undefined}
      onClick={() => isTotal && onRowClick?.(isTotal, rowData)}
      style={{ cursor: isTotal ? 'pointer' : 'default' }}
      title={ isTotal ? 'Epand / Colapse' : '' }
    >
      {row.map((cell, index) => {
        if (typeof cell === "string") {
          return <MuiTableCell key={index + 1} classes={cellStyles} dangerouslySetInnerHTML={{ __html: sanitize(cell) }}></MuiTableCell>;
        } else {
          if (isTotal) {
            const element = cell as React.ReactElement<{ children?: React.ReactNode }>;
            return (
              <MuiTableCell key={index + 1} classes={cellStyles}>
                {element.props.children}
              </MuiTableCell>
            );
          }
          return (
            <MuiTableCell key={index + 1} classes={cellStyles}>
              {cell}
            </MuiTableCell>
          );
        }
      })}
    </MuiTableRow>
  );
};

export default TableRow;
